import React, { Suspense, lazy } from 'react'

import ReactDOM from 'react-dom/client'
import { Selectors } from './const/selectors.const'

const Story = lazy(() => import('./modules/Story/App'))
const Highlights = lazy(() => import('./modules/Highlights/App'))
const Carrossel = lazy(() => import('./modules/Carrossel/App'))
const ConfigurationPreview = lazy(
  () => import('./modules/ConfigurationPreview/App')
)

class StoryComponent extends HTMLElement {
  connectedCallback() {
    const mountPoint = document.createElement('div')
    this.attachShadow({ mode: 'open' }).appendChild(mountPoint)
    mountPoint.className = 'widde widde-video'
    this.setAttribute('widde', 'true')
    const root = ReactDOM.createRoot(mountPoint)
    root.render(
      <React.StrictMode>
        <Suspense fallback={null}>
          <Story />
        </Suspense>
      </React.StrictMode>
    )
  }
}

class HighlightsComponent extends HTMLElement {
  connectedCallback() {
    const mountPoint = document.createElement('div')
    this.attachShadow({ mode: 'open' }).appendChild(mountPoint)
    mountPoint.className = 'widde widde-highlights'
    this.setAttribute('widde', 'true')
    const root = ReactDOM.createRoot(mountPoint)

    root.render(
      <React.StrictMode>
        <Suspense fallback={null}>
          <Highlights />
        </Suspense>
      </React.StrictMode>
    )
  }
}

class CarrosselComponent extends HTMLElement {
  connectedCallback() {
    const mountPoint = document.createElement('div')
    this.attachShadow({ mode: 'open' }).appendChild(mountPoint)
    mountPoint.className = 'widde widde-video'
    const collectionKey = this.getAttribute('collection-key') || ''
    this.setAttribute('widde', 'true')
    const root = ReactDOM.createRoot(mountPoint)

    root.render(
      <React.StrictMode>
        <Suspense fallback={null}>
          <Carrossel collectionKey={collectionKey} />
        </Suspense>
      </React.StrictMode>
    )
  }
}
class WiddeConfigurationPreviewComponent extends HTMLElement {
  connectedCallback() {
    const mountPoint = document.createElement('div')
    this.attachShadow({ mode: 'open' }).appendChild(mountPoint)
    mountPoint.className = 'widde widde-video'
    this.setAttribute('widde', 'true')
    const root = ReactDOM.createRoot(mountPoint)

    root.render(
      <React.StrictMode>
        <Suspense fallback={null}>
          <ConfigurationPreview />
        </Suspense>
      </React.StrictMode>
    )
  }
}

const TAGS = {
  StoryComponent: 'widde-story',
  CarrosselComponent: 'widde-carrossel',
  HighlightsComponent: 'widde-highlights',
  WiddeConfigurationPreviewComponent: 'widde-configuration-preview'
}
customElements.define(TAGS.StoryComponent, StoryComponent)
customElements.define(TAGS.CarrosselComponent, CarrosselComponent)
customElements.define(TAGS.HighlightsComponent, HighlightsComponent)
customElements.define(
  TAGS.WiddeConfigurationPreviewComponent,
  WiddeConfigurationPreviewComponent
)
;(() => {
  const style = document.createElement('style')
  style.innerHTML = `
    .widde-no-scroll{
      overflow: hidden !important;
    }
`

  document.head.append(style)

  let div: HTMLDivElement | undefined = undefined
  if (document.querySelector('.mm-page.mm-slideout'))
    div = document.querySelector('.mm-page.mm-slideout') as HTMLDivElement
  if (window.location.href.includes('widde-configuration-preview')) {
    createDiv(TAGS.WiddeConfigurationPreviewComponent, div)
  } else {
    createDiv(TAGS.StoryComponent, div)
  }
  searchForDivs()

  function createDiv(
    divType: string,
    parent?: HTMLDivElement,
    attributes?: any
  ) {
    const div = document.createElement(divType)

    if (attributes) {
      Object.keys(attributes).map(key => div.setAttribute(key, attributes[key]))
    }
    const _add = parent || document.body
    _add.appendChild(div)
    return div
  }
  function searchForDivs() {
    // const _div = document.querySelector("#shopify-section-featured-collections");
    // if (_div) _div.className += " widdeDiv ";
    const divs = document.querySelectorAll('.' + Selectors.widdeDiv)
    for (let i = 0; i < divs.length; i++) {
      const div: HTMLDivElement = divs[i] as HTMLDivElement
      const collectionKey = div.getAttribute('data-collection-key')
      if (collectionKey) {
        const _div = createDiv(TAGS.CarrosselComponent, div, {
          'collection-key': collectionKey
        })
      }
    }
  }

  try {
    const urlParams = new URLSearchParams(window.location.search)
    const feature = urlParams.get('widde-feature-test')
    if (feature && document.querySelector(feature)) {
      const h1 = document.querySelector(feature)
      if (h1) {
        const parent = h1.parentElement
        if (parent) {
          const index = Array.prototype.indexOf.call(parent.childNodes, h1)

          const child = document.createElement(TAGS.HighlightsComponent)

          const refChild = parent.children[index + 1]
          parent.insertBefore(child, refChild)
        }
      }
    }
  } catch (error) {}
})()

// const className = " widde-video ";

// //@ts-ignore
// window.WiddeVideo = {
//   searchForDivs,
// };
// async function bodyReady() {
//   return new Promise(async (resolve, reject) => {
//     if (document.body) return resolve(true);
//     for (let index = 0; index < 10; index++) {
//       await new Promise((r) => setTimeout(r, 400));
//       if (document.body) return resolve(true);
//     }
//     reject(false);
//   });
// }

// (async () => {
//   await bodyReady();
//   // debugger;
//   const div = document.createElement("div");
//   div.id = "widde_video 222";
//   div.className = className;
//   const root = ReactDOM.createRoot(div);
//   document.body.append(div);
//   // document.body.insertBefore(div, document.body.firstChild);
//   searchForDivs();
//   if (!window.location.href.includes("widde-configuration-preview"))
//     root.render(
//       <React.StrictMode>
//         <Suspense fallback={null}>
//           <App>
//             <NavigationContainer />
//             <Story />
//           </App>
//         </Suspense>
//       </React.StrictMode>
//     );
//   else
//     root.render(
//       <React.StrictMode>
//         <Suspense fallback={null}>
//           <ConfigurationPreview />
//         </Suspense>
//       </React.StrictMode>
//     );
// })();
